import script from "./TcMenu.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcMenu.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TcMenu.vue.scss?vue&type=style&index=0&id=5c709833&scoped=true&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcMenu.vue?vue&type=style&index=0&id=5c709833&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c709833"]])

export default __exports__